// set types here so imports specify what reducers we're using in what compeonent

export const GET_WEATHER = 'GET_WEATHER';
export const FLIP_SCALE = 'FLIP_SCALE';
export const SET_LOCATION = 'SET_LOCATION';
export const GET_HOURLY = 'GET_HOURLY';
export const SET_LOCALSTATE = 'SET_LOCALSTATE';
